import { useCallback, useEffect, useState } from "react";
import { PLANNING_STATES } from "../classes/enums/PlanningStateEnum";
import { SPINESIM_MODALITIES } from "../classes/enums/MedicalImagesEnum";

/**
 * Custom hook to manage data fusion functionality in Check module
 * @param {Object} params - Hook parameters
 * @returns {Object} Data fusion state and functions
 */
const useCheckDataFusion = ({
  areViewsReady,
  renderClient,
  getFusionVisibilityState,
  showCtFusionView,
  hideCtFusionView,
  handleSelectModality,
  isFusionApplicable,
}) => {
  const [isDataFusionActive, setIsDataFusionActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Callback: Toggle data fusion
  const handleToggleDataFusion = useCallback(async () => {
    setIsLoading(true);
    handleSelectModality(SPINESIM_MODALITIES.DX);
    try {
      if (isDataFusionActive) {
        await hideCtFusionView(PLANNING_STATES.CHECK);
      } else {
        await showCtFusionView(PLANNING_STATES.CHECK);
      }
      setIsDataFusionActive(prev => !prev);
    } catch (error) {}
    setIsLoading(false);
  }, [
    handleSelectModality,
    isDataFusionActive,
    hideCtFusionView,
    showCtFusionView,
  ]);

  // Effect: Check fusion state on mount and when views become ready
  useEffect(() => {
    if (!renderClient || !areViewsReady || !isFusionApplicable) return;

    const checkFusionState = async () => {
      try {
        const fusionVisibilityState = await getFusionVisibilityState(
          PLANNING_STATES.CHECK
        );
        setIsDataFusionActive(fusionVisibilityState);
      } catch (error) {
        setIsDataFusionActive(false);
      }
    };

    checkFusionState();
  }, [areViewsReady, getFusionVisibilityState, renderClient, isFusionApplicable]);

  return {
    isDataFusionActive,
    isDataFusionLoading: isLoading,
    handleToggleDataFusion,
  };
};

export default useCheckDataFusion;
